import { html } from "lit";
import { property } from "lit/decorators.js";
import { LeafElement } from "../../components/leaf-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
class CHCMetaTagReplacer extends LeafElement {
  render() {
    const metaContent = document.querySelector(`meta[name="${this.metaTag}"]`);
    if (metaContent) {
      return html`${metaContent.getAttribute("content")}`;
    }
    return html`<slot></slot>`;
  }
}
__decorateClass([
  property({ reflect: true })
], CHCMetaTagReplacer.prototype, "metaTag", 2);
export {
  CHCMetaTagReplacer
};
//# sourceMappingURL=meta-tag-replacer.component.js.map
